import React from 'react';
import { useForm } from 'react-hook-form';
import { usePushEvents } from '../../../../hooks/PushEvents';
import {
    emailOnMainAuth,
    loginPopup,
} from '../../../../hooks/PushEvents/clevertapEvents';

export type EmailFormValues = {
    email: string;
};

export const useEmailStep = (
    onEmailSubmit: (email: string) => void,
    defaultEmail?: string,
) => {
    const { pushEvent } = usePushEvents();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<EmailFormValues>({
        defaultValues: { email: defaultEmail ?? '' },
    });

    const onSubmit = handleSubmit((data) => {
        pushEvent(emailOnMainAuth);
        onEmailSubmit(data.email);
    });

    React.useEffect(() => {
        pushEvent(loginPopup);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { register, errors, onSubmit };
};
